import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const reports = [
  { id: "profitLoss", title: "Profit & Loss", description: "Income, costs, and operating expenses for a selected period.", icon: FiIcons.FiTrendingUp, available: true },
  { id: "balanceSheet", title: "Balance Sheet", description: "Assets, liabilities, and equity as of a selected date.", icon: FiIcons.FiLayers, available: true },
  { id: "cashFlow", title: "Cash Flow Statement", description: "Cash movements grouped by operating, investing, and financing activity.", icon: FiIcons.FiActivity, available: false },
  { id: "trialBalance", title: "Trial Balance", description: "Debit and credit balances across the organization's posted ledger.", icon: FiIcons.FiCheckSquare, available: true },
  { id: "generalLedger", title: "General Ledger", description: "Chronological posted activity and running balance for one account.", icon: FiIcons.FiBookOpen, available: true },
];

export default function ClientReportSelector({ value, onChange }) {
  return (
    <section className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5" aria-label="Choose a financial report">
      {reports.map((report) => {
        const selected = value === report.id;
        return (
          <button
            key={report.id}
            type="button"
            onClick={() => onChange(report.id)}
            aria-pressed={selected}
            className={`rounded-2xl border p-4 text-left transition ${
              selected
                ? "border-violet-300 bg-violet-50 shadow-sm"
                : "border-slate-200 bg-white hover:border-violet-200 hover:bg-slate-50"
            }`}
          >
            <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${
              selected ? "bg-violet-100 text-violet-700" : "bg-slate-100 text-slate-600"
            }`}>
              <SafeIcon icon={report.icon} />
            </span>
            <span className="mt-3 block text-sm font-bold text-slate-900">{report.title}</span>
            <span className="mt-1 block text-xs leading-5 text-slate-500">{report.description}</span>
            {!report.available && (
              <span className="mt-3 inline-block rounded-full bg-amber-50 px-2 py-1 text-[10px] font-bold text-amber-700">
                Temporarily unavailable
              </span>
            )}
          </button>
        );
      })}
    </section>
  );
}